import download from "./download";
import axios from 'axios'

async function downloadInProgressTransactionsExcel() {
    const token = localStorage.getItem('token')
    try {
        const url = `${process.env.REACT_APP_API_URL}/admin/download/in-progress/excel`;
        axios({
          url: url,
          method: "GET",
          responseType: 'blob',
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response: any) => {
            download(
                response.data,
                `In Progress Transactions`,
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              );
        })
      } catch (error) {
        console.error("File missing")
      }
}

export default downloadInProgressTransactionsExcel;